function get(name) {
  const cName = name + '='
  const decodedCookie = decodeURIComponent(document.cookie)
  let ca = decodedCookie.split(';')
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i]
    while (c.charAt(0) === ' ') {
      c = c.substring(1)
    }
    if (c.indexOf(cName) === 0) {
      return c.substring(cName.length, c.length)
    }
  }

  return null
}

function set(name, content, expiration) {
  document.cookie = `${name}=${content}; expires=${expiration}; path=/`
}

function remove(name) {
  let d = new Date()
  d.setDate(d.getDate() - 1)

  document.cookie = `${name}=; expires=${d}; path=/;`
}

const Cookie = {
  get: get,
  set: set,
  remove: remove
}

export default Cookie
